import React from 'react'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { CheckboxBodyCell } from '@ztechapps/webui.data-tools'
import { RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import { useSerialNumberSelectListContext } from './Context'
import type { InventoryBySerialNumberWithSelection } from './types'
import { InventoryBySerialNumberStatus } from '../Status/InventoryBySerialNumberStatus'
import { BusyButtonLink } from '@ztechapps/webui.button'

const CodeColumn = (props: BodyRowConfig<InventoryBySerialNumberWithSelection> & { disabled?: boolean }) => {
  const context = useSerialNumberSelectListContext()
  const { toggleSelectBy } = context.listWithSelection
  const { _id, code } = props

  const handleToggle = () => {
    toggleSelectBy((item) => item._id === _id)
  }

  return <BusyButtonLink disabled={props.disabled} onClick={handleToggle} text={code} />
}

const StatusColumn = (props: BodyRowConfig<InventoryBySerialNumberWithSelection>) => {
  const { status } = props
  return <InventoryBySerialNumberStatus status={status} />
}

export const ListRow = (props: BodyRowConfig<InventoryBySerialNumberWithSelection>) => {
  const { batchCode } = props

  const context = useSerialNumberSelectListContext()
  const { toggleSelectBy } = context.listWithSelection
  const { maxSelection } = context
  const { _id, _selected } = props

  const selectedCount = context.listWithSelection.selectedList.length
  const isMaxReached = maxSelection !== undefined && selectedCount >= maxSelection && !_selected
  const isDisabled = isMaxReached

  const handleToggle = () => {
    toggleSelectBy((item) => item._id === _id)
  }

  return (
    <>
      <RowNumberBodyCell {...props} />
      <CheckboxBodyCell checked={_selected} disabled={isDisabled} onChange={handleToggle} />
      {props._renderDataBodyCell({
        code: <CodeColumn {...props} disabled={isDisabled} />,
        status: <StatusColumn {...props} />,
        batchCode: batchCode,
      })}
    </>
  )
}
